// Node
import i18next from 'i18next';
import FunnySadDialog from 'new_design/common/funny-sad-dialog';

const $ = require('jquery');
require('jquery-ujs');

// Custom
import moment from 'moment';
import { callToCallCenterInit, hideOtherTariffs, updateFixedBookButton } from 'new_design/common/camps/show/utils';
import i18CustomParams from 'new_design/common/i18_custom';
import SearchForm from './common';
import { mergeApartments } from './merge_apartments';

class ApartmentsForm extends SearchForm {
  static init(formId) {
    return new ApartmentsForm(formId);
  }

  constructor(formId, options = { lazyLoad: false }) {
    super(formId);

    i18next.init(i18CustomParams(), function (err, t) {});

    this.$submitBtn = this.$form.find('#apartments_search_button');
    this.$resetBtn = this.$form.find('#apartments_reset_search_data');
    this.$dateRangeAlert = $('.date-range-alert-text');
    this.$dataField = $('#apartments_data');
    this.$tariffsModals = $('#tariffs_modals');
    this.$tariffPlacementModals = $('#tariff_placement_modals');
    this.$tariffConditionModals = $('#tariff_condition_modals');
    this.$tariffPrepaymentInfoModals = $('#tariff_prepayment_info_modals');
    this.$bonusesModals = $('#bonuses_modals');
    this.$apartmentsModals = $('#apartments_modals');
    this.$fixedBookButton = $('#fixed_book_button');
    this.$bookingWhatsapp = $('#booking_whatsapp');
    this.$errorField = $('#apartments_error');
    this.$networkErrorField = $('#apartments_network_error');
    this.$loader = $('#apartments_load');
    this.$labelWithReward = $('#label-with-reward');
    this.minDateRange = 7; // 7 - MIN_DATE_RANGE (см. module Sanatoriums::SearchWidgetHelper)
    this.maxNumberOfApsToShowDateAlert = 2;
    this.options = options;
    this.$fastBookFormContainer = $('.fast-book-form__container');
    this.fastBookFormRevealed = false;

    this.$fixedBookButton.on('click', (e) => {
      this.$fixedBookButton.hide();
    });

    this.$submitBtn.off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.refresh();
    });

    this.isNewSearch = false;
  }

  async _init() {
    let search_data = await SearchForm.getSearchData();
    this.totalGuestCount = search_data.adults_count + search_data.children_count;
    this.$form.find('#apartments_dates').val(search_data.dates_range_printable);
    $('#apartments_dates').val(search_data.dates_range_printable);
    this.$form.find('.dates_mobile_input').val(search_data.dates_range_printable_long);
    this.$form.find('#apartments_total_adults_count').val(search_data.adults_count);
    this.$form.find('#apartments_count_guests').val(search_data.adults_count);
    this.$form.find('#apartments_total_children_count').val(search_data.children_count);
    this.$form.find('#apartments_children_count').val(search_data.children_count);
    this.$form.find('#children_count').val(search_data.children_count);
    this.$form.find('#children_count_numb').html(search_data.children_count);
    $('#search-guest').find('#children_count_numb').html(search_data.children_count);
    $('#apartments_search-guest').find('#children_count_numb').html(search_data.children_count);
    $('#search-guest').find('#count_guests_numb').html(search_data.adults_count);
    $('#apartments_search-guest').find('#count_guests_numb').html(search_data.adults_count);
    this.$form.find('#apartments_count_guests').val(search_data.adults_count);
    this.$form.find('#count_guests_numb').html(search_data.adults_count);
    this.$form.find('#apartments_children_ages').data('ages', search_data.children_ages);
    this.$form.find('#search_string').val(search_data.search_string);
    this.$form.find('#search_string_base').html(search_data.search_string);
    this.$form.find('#search_id').val(search_data.search_id);
    this.$form.find('#old_search_id').val(search_data.search_id);
    this.$form.find('#search_type').val(search_data.search_type);
    this.$form.find('#apartments_date_start').val(search_data.date_start);
    this.$form.find('#apartments_date_end').val(search_data.date_end);
    if (this.$form.find('#search_type').val() !== 'camp')
      this.$form.find('#old_search_type').val(search_data.search_type);
    if (search_data.children_count > 0) {
      $('#search-guest').find('#guest-child-title').removeClass('hidden').show();
      $('#apartments_search-guest').find('#guest-child-title').removeClass('hidden').show();
      this.$form.find('#guest-child-title').removeClass('hidden').show();
    }
    if (search_data.our_stuff) {
      this.$form.find('#apartments_reset_search_data').removeClass('hidden');
      this.$form.find('#apartments_load_from_travel_line').removeClass('hidden');
    }

    const petsForbidden = this.$form.find('#apartments_with_pet_checkbox').prop('disabled') === true;
    const withPet = petsForbidden ? false : search_data.with_pet;
    if (withPet) this.$form.find('#apartments_with_pet_string').removeClass('hidden');
    $('#apartments_with_pet_checkbox').prop('checked', withPet);
    this.$form.find('#apartments_with_pet').val(withPet);

    super._init();

    this._ajaxInit();
    this._metrikaInit();

    this.datePicker.init();
    this.guestsWidget.init();

    if (this.options.lazyLoad) {
      this.$form.trigger('submit');
    } else {
      const btnText =
        window.isMobileDevice && !(search_data.date_start && search_data.date_end) ? 'Показать цены' : 'Забронировать';
      const textButton =
        '<a class="border-rounded typography-normal button-fullwidth button-green">\
             ' +
        btnText +
        '\
             </a>\
           <p class="typography-small typography-small-black margin-top-8 text-center">\
            <span class="fixed_book_button__nights"></span>\
        </p>';
      this.$fixedBookButton.html(textButton);
      updateFixedBookButton();
      this._eventsInit();
    }
    this.loaded = false;
  }

  _ajaxInit() {
    this.$form.on('ajax:beforeSend', (event, xhr) => {
      if (this._currentXHR) {
        this._currentXHR.abort();
      }
      if (this._pendingServicesXHR) {
        this._pendingServicesXHR.abort();
      }
      this._currentXHR = xhr;
      this.isNewSearch = true;
      this.$form.serialize();
      this._setLoading();
    });

    this.$form.on('ajax:success', (event, data) => {
      this._currentXHR = null;
      this._processSuccessResponse(data, true);
      if (data['pending_services'] && data['pending_services'].length > 0) {
        this._loadPendingServices(data['pending_services'], data);
      } else {
        this._unsetLoading();
      }
      clearApartmentHashFromHistory();
    });

    this.$form.on('ajax:error', (event, xhr, status) => {
      if (xhr.statusText === 'abort' || status === 'abort') return;
      this._currentXHR = null;
      this._processErrorResponse(this._isNetworkError(xhr, status));
    });
  }

  _metrikaInit() {
    this.$submitBtn.on('click', () => {
      window.ymReachGoal('search-camp-metrika');
    });
  }

  _metrikaTariffs() {
    $('.other_tariffs_show').on('click', () => {
      window.ymReachGoal('other-tariffs-show');
    });

    $('.other_tariffs_hide').on('click', () => {
      window.ymReachGoal('other-tariffs-hide');
    });

    $('.btn_new_book').on('click', () => {
      window.ymReachGoal('booking-form-metrika');
    });

    $('.rooms-box-info__price .btn_new_bid').on('click', () => {
      window.ymReachGoal('parting-form-metrika');
    });
  }

  _aleanPacketDescription() {
    $('.alean_packet_descr').each(function () {
      // По наведению курсора
      $(this).mouseenter(() => {
        let $description = $(this).find('.description');
        let $loading = $(this).find('.loading__img');

        // Если еще не отправляли запрос и описания нет
        if ($description.text() === '') {
          $description.text(' ');
          $.ajax({
            url: `/camps/${$(this).data('id')}/${$(this).data('method')}.json`,
            type: 'GET',
            dataType: 'json',
            success: function (res) {
              if (typeof res.data === 'string') {
                $description.text(res.data);
              } else {
                $description.text('Описание отсутствует');
              }
              $loading.addClass('hidden');
            },
            error: function (res) {
              FunnySadDialog.createSadDialog(
                'Произошла ошибка.',
                'Попробуйте обновить вкладку браузера или повторите попытку через несколько минут'
              );
            },
          });
        }
      });
    });
  }

  _eventsInit() {
    $('.open_popup:not(.guest-child__input-item_open_popup)').each(function () {
      $(this).on('click', function (e) {
        e.stopPropagation();
      });
    });
    hideOtherTariffs();
    callToCallCenterInit();
    if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
    let datePicker = this.datePicker;

    $('.mt_disabled_booking_apartment').each(function () {
      $(this).on('click', function (e) {
        e.stopPropagation();
        return datePicker.open();
      });
    });

    $('.mt_disabled_booking_apartment_mobile').each(function () {
      $(this).on('click', function (e) {
        e.stopPropagation();
        if ($(this).parent().parent().hasClass('modal_fixed_book_button')) {
          $(this).closest('.popup').addClass('active_popup');
        }
        return datePicker.open(true);
      });
    });

    $('.search-none__btn > button, .search-none__btn > a').on('click', (event) => {
      if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
      if ($(event.currentTarget).is('#apartments_network_retry')) {
        this.refresh();
      } else {
        this.reset();
      }
    });

    let searchInput = this.$form.find('.search-item input'),
      guestInput = this.$form.find('.search-item__guest'),
      guestWindow = this.$form.find('.guest'),
      btnCloseGuests = this.$form.find('#guests-close-modal');

    const handleWindowSwitch = (input, window, areaClick) => {
      input.off('click');
      input.on('click', (e) => {
        window.fadeIn();
      });

      searchInput.not(input).on('focus', (e) => {
        window.fadeOut();
      });

      btnCloseGuests.off('click');
      btnCloseGuests.on('click', (e) => {
        window.fadeOut();
        this.refresh();
      });

      if (areaClick) {
        $(document).on('mouseup', (e) => {
          if (!window.is(e.target) && window.has(e.target).length === 0 && !input.is(e.target)) {
            window.fadeOut();
            // this.refresh(); // TODO
          }
        });
      }
    };

    handleWindowSwitch(guestInput, guestWindow, true);

    this.$resetBtn.on('click', () => {
      this.reset();
    });
  }

  _setLoading() {
    this.$dataField.addClass('hidden');
    this.$errorField.addClass('hidden');
    this.$networkErrorField.addClass('hidden');
    this.$loader.removeClass('hidden');
    $('div.date-range-alert-text').remove();
    this.$resetBtn.prop('disabled', true);
    this.$submitBtn.prop('disabled', true);
    $('.rooms-list-title').addClass('hidden');
  }

  _loadDateRangeAlert() {
    if (
      this.datePicker.startDate &&
      this.datePicker.endDate &&
      moment.duration(this.datePicker.endDate.diff(this.datePicker.startDate)).asDays() < this.minDateRange &&
      $('ul.rooms-list').children('li').length < this.maxNumberOfApsToShowDateAlert
    ) {
      if (this.$dateRangeAlert) {
        let children_ages = [];
        this.$form.find("input[name='children_ages[]']").each((i, el) => children_ages.push($(el).val()));
        $.ajax({
          url: `/camps/date_range_alert`,
          type: 'POST',
          data: {
            camp_id: this.$form.find("input[name='search_id']").val(),
            date_start: this.$form.find("input[name='date_start']").val(),
            date_end: this.$form.find("input[name='date_end']").val(),
            count_guests: this.$form.find("input[name='apartments_total_adults_count']").val(),
            children_ages: children_ages.join(','),
          },
          success: function (res) {
            $('#date_range_alert').append(res);
          },
        });
      }
    }
  }

  _unsetLoading(error = false, hasApartments = false, network = false) {
    this.$loader.addClass('hidden');
    this.$errorField.addClass('hidden');
    this.$networkErrorField.addClass('hidden');
    if (error && !hasApartments) {
      (network ? this.$networkErrorField : this.$errorField).removeClass('hidden');
    } else {
      this.$dataField.removeClass('hidden');
    }
    if (!this.fastBookFormRevealed) {
      this.$fastBookFormContainer.removeClass('hidden');
      this.fastBookFormRevealed = true;
    }
    this.$resetBtn.prop('disabled', false);
    this.$submitBtn.prop('disabled', false);
    $('.rooms-list-title').removeClass('hidden');
  }

  _aleanPrepayment() {
    $('.packet_description.alean-prepayment').each(function () {
      $(this).mouseenter(() => {
        const tooltipPrepayment = $(this).find('.alean-prepayment_tooltip');
        const data = tooltipPrepayment.data('prepayment_data') ?? {};
        const instant = { data };
        const confirmationText = instant ? '' : ' после подтверждения бронирования';

        if (tooltipPrepayment.data('loaded')) {
          return;
        }

        $.ajax({
          url: `/booking_widgets/prepayment_alean`,
          method: 'GET',
          data: {
            ...data,
            camp_id: window.camp.id,
          },
          beforeSend: function () {
            tooltipPrepayment.text('Загрузка...');
          },
          success: function (res) {
            if (res !== undefined && res !== null) {
              tooltipPrepayment.text(
                `Требуется внесение предоплаты в течение 2 часов${confirmationText} на условиях ${res.data.first_pay} сейчас и ${res.data.second_pay} до ${res.data.date}`
              );
            } else {
              tooltipPrepayment.text(
                `Требуется внесение предоплаты в течение 2 часов${confirmationText}. Сумма предоплаты составляет 100%`
              );
            }
            tooltipPrepayment.data('loaded', true);
          },
          error: function (xhr, status, error) {
            console.error(error);
          },
        });
      });
    });
  }

  _delfinPrepayment() {
    $('.packet_description.delfin-prepayment').each(function () {
      $(this).mouseenter(() => {
        const tooltipPrepayment = $(this).find('.delfin-prepayment_tooltip');
        const data = tooltipPrepayment.data('prepayment_data') ?? {};
        const { instant } = data;
        const confirmationText = instant ? '' : ' после подтверждения бронирования';

        if (tooltipPrepayment.data('loaded')) {
          return;
        }

        $.ajax({
          url: `/booking_widgets/prepayment_delfin`,
          method: 'GET',
          data: {
            ...data,
            camp_id: window.camp.id,
          },
          beforeSend: function () {
            tooltipPrepayment.text('Загрузка...');
          },
          success: function (res) {
            if (res !== undefined && res !== null) {
              tooltipPrepayment.text(
                `Требуется внесение предоплаты в течение 2 часов${confirmationText} на условиях ${res.data.first_pay} сейчас и ${res.data.second_pay} до ${res.data.date}`
              );
            } else {
              tooltipPrepayment.text(
                `Требуется внесение предоплаты в течение 2 часов${confirmationText}. Сумма предоплаты составляет 100%`
              );
            }

            tooltipPrepayment.data('loaded', true);
          },
          error: function (xhr, status, error) {
            console.error(error);
          },
        });
      });
    });
  }

  _loadAvailableDates() {
    const loadingBlock = $('#available-dates-loading');
    loadingBlock.show();

    const resultsContainer = $('#available-dates-results');

    $.ajax({
      url: '/booking_widgets/available_dates',
      method: 'GET',
      data: this.$form.serialize(),
      success: (data) => {
        loadingBlock.hide();

        if (data.available_dates && data.available_dates.length > 0) {
          resultsContainer.html(data.html).show();
        } else {
          resultsContainer
            .html(
              `
              <div class="alert__wrapper">
                На выбранные даты нет свободных номеров
              </div>
              <div class="available-dates__title">
                Ближайшие доступные даты не найдены
              </div>`
            )
            .show();
        }

        this._initAvailableDatesEvents();

        requestAnimationFrame(() => {
          window.dispatchEvent(new Event('update-tab-slider-height'));
        });
      },
      error: function (xhr, status, error) {
        console.error(error);
        loadingBlock.hide();
      },
    });
  }

  _initAvailableDatesEvents() {
    $('.available-dates__item').click(function (e) {
      let startDate = moment($(this).data('date_start'), 'DD-MM-YYYY');
      let endDate = moment($(this).data('date_end'), 'DD-MM-YYYY');
      let range = { startDate: startDate, endDate: endDate };

      window.apartmentsDatePicker.updateDatesOutside(range);
      window.apartmentsDatePicker.setNightsCount();
    });
  }

  _loadPendingServices(pendingServices, firstResponseData) {
    this._firstResponseData = firstResponseData;

    $('.btn_new_book').addClass('loading');

    pendingServices.forEach((service) => {
      const $retryInput = $('<input>').attr('type', 'hidden').attr('name', 'services[]').val(service.trim());
      this.$form.append($retryInput);
    });

    this._pendingServicesXHR = $.ajax({
      url: this.$form.attr('action'),
      type: this.$form.attr('method'),
      data: this.$form.serialize(),
      success: (retryData) => {
        this._pendingServicesXHR = null;
        this.$form.find('input[name="services[]"]').remove();
        const isSearchNone = retryData.full.includes('search-none');
        mergeApartments(
          this._firstResponseData,
          retryData,
          this._updateApartmentsCount.bind(this),
          this.totalGuestCount
        );
        retryData._isSearchNone = isSearchNone;
        this._processSuccessResponse(retryData, false);

        $('.btn_new_book').removeClass('loading');
      },
      error: (xhr, status) => {
        this._pendingServicesXHR = null;
        this.$form.find('input[name="services[]"]').remove();
        if (xhr.statusText === 'abort' || status === 'abort') {
          $('.btn_new_book').removeClass('loading');
          return;
        }
        this._processErrorResponse(this._isNetworkError(xhr, status));

        $('.btn_new_book').removeClass('loading');
      },
    });
  }

  _processSuccessResponse(data, isFirst) {
    window.search_data ??= {};
    window.search_data.date_start = document.getElementById('apartments_date_start').value;
    window.search_data.date_end = document.getElementById('apartments_date_end').value;
    window.search_data.count_guests = +document.getElementById('apartments_total_adults_count')?.value;

    let childrenAges = [];
    const totalChildrenCount = this.$form.find("input[name='apartments_total_children_count']").val();
    const childrenAgesMobile = document.querySelectorAll(
      '.guest-child__input.apartments_children_ages input[name="children_ages[]"]'
    );
    if (childrenAgesMobile.length > 0) {
      childrenAgesMobile.forEach((el) => {
        childrenAges.push(el.value);
      });
    } else if (totalChildrenCount && totalChildrenCount > 0) {
      childrenAges = Array.from(
        document.querySelectorAll('#search-form-apartments #children_age_input'),
        (input) => input.value
      );
    }
    window.search_data.children_ages = childrenAges;
    window.search_data.children_count = childrenAges.length;
    window.search_data.adults_count = window.search_data.count_guests;

    this.totalGuestCount = window.search_data.adults_count + window.search_data.children_count;

    const communicationPopupWasOpen =
      Array.isArray(window.openedPopupsIdsStack) && window.openedPopupsIdsStack.includes('#communication-method-popup');

    if (this.$labelWithReward.length && data['new_camp_reward_label']) {
      this.$labelWithReward.html(data['new_camp_reward_label']);
    }

    const isSearchNone = isFirst ? data['full'].includes('search-none') : data._isSearchNone;
    const noServices = data['pending_services'] && data['pending_services'].length === 0;

    // Большие скелетоны убираем сразу после первой пачки: и когда номеров нет,
    // и когда карточки уже пришли, а остальные службы ещё грузятся.
    if (isFirst) {
      $('#apartments_data_loading').addClass('hidden');
    }

    if (isSearchNone) {
      this.$dataField.removeClass('hidden');
      if (noServices || !isFirst) {
        this.$loader.addClass('hidden');
      }
    } else if (isFirst) {
      this.$dataField.removeClass('hidden');
    }

    this._updateApartmentList(data['full'], {
      skipAnimation: isSearchNone,
      forceAnimation: this.isNewSearch,
    });

    if ((isFirst && noServices) || !isFirst) {
      const $apartmentsList = this.$dataField.find('ul.rooms-list');
      this._updateApartmentsCount($apartmentsList);
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('update-tab-slider-height'));
      });
    }

    if (this.$tariffsModals.length > 0) {
      if (isFirst) {
        this.$tariffsModals.html(data['tariffs_modals']);
      } else {
        this.$tariffsModals.append(data['tariffs_modals']);
      }
    }
    if (this.$tariffPlacementModals.length > 0) {
      if (isFirst) {
        this.$tariffPlacementModals.html(data['tariff_placement_modals']);
      } else {
        this.$tariffPlacementModals.append(data['tariff_placement_modals']);
      }
    }
    if (this.$tariffConditionModals.length > 0) {
      if (isFirst) {
        this.$tariffConditionModals.html(data['tariff_condition_modals']);
      } else {
        this.$tariffConditionModals.append(data['tariff_condition_modals']);
      }
    }
    if (this.$tariffPrepaymentInfoModals.length > 0) {
      if (isFirst) {
        this.$tariffPrepaymentInfoModals.html(data['tariff_prepayment_info_modals']);
      } else {
        this.$tariffPrepaymentInfoModals.append(data['tariff_prepayment_info_modals']);
      }
    }
    if (this.$bonusesModals.length > 0) {
      this.$bonusesModals.html(data['bonuses_modals']);
    }
    if (this.$apartmentsModals.length > 0) {
      if (isFirst) {
        this.$apartmentsModals.html(data['apartments_modals']);
      } else {
        this.$apartmentsModals.append(data['apartments_modals']);
      }
    }
    if (this.$fixedBookButton.length > 0) {
      this.$fixedBookButton.html(data['fixed_book_button']);
      updateFixedBookButton();
    }
    if (this.$bookingWhatsapp.length > 0 && !communicationPopupWasOpen) {
      this.$bookingWhatsapp.html(data['booking_whatsapp']);
    }
    if (data.has_places) {
      $('#contacts').show();
      $('#contacts_question').show();
      $('.reserv__phones').show();
    } else {
      $('#contacts').hide();
      $('#contacts_question').hide();
      $('.reserv__phones').hide();
    }

    const countGuests = window.isMobileDevice
      ? this.$form.find("input[name='count_guests']").val()
      : this.$form.find("input[name='apartments_total_adults_count']").val();

    updateUrl(
      countGuests,
      this.$form.find("input[name='apartments_total_children_count']").val(),
      this.$form.find("input[name='date_end']").val(),
      this.$form.find("input[name='date_start']").val(),
      $('#apartments_with_pet_checkbox').prop('checked')
    );

    if (!isFirst) {
      this._unsetLoading();
    } else {
      this._loadDateRangeAlert();
    }

    this._eventsInit();
    this._metrikaTariffs();
    this._aleanPacketDescription();
    this._aleanPrepayment();
    this._delfinPrepayment();

    if (data.no_available_tariffs && ((isFirst && noServices) || !isFirst)) {
      const hasPricedApartments = this.$dataField
        .find('.rooms-list-item')
        .toArray()
        .some((apartment) => {
          const pricesBySeats = $(apartment).data('prices-by-seats');
          return pricesBySeats && Object.keys(pricesBySeats).length > 0;
        });

      if (!hasPricedApartments) {
        this._loadAvailableDates();
      }
    }

    $('#load-more-apartments').on('click', function () {
      $('[data-additional="true"]:not([data-no_price="true"])').removeClass('hidden');
      $(this).hide();
      $('#show-apartments-no-price').removeClass('hidden');
      window.dispatchEvent(new Event('update-tab-slider-height'));
    });

    $('#show-apartments-no-price').on('click', function () {
      $('[data-no_price="true"]').removeClass('hidden');
      $(this).hide();
      window.dispatchEvent(new Event('update-tab-slider-height'));
    });
  }

  _isNetworkError(xhr, status) {
    return status === 'timeout' || !xhr || xhr.status === 0;
  }

  _processErrorResponse(network = false) {
    const hasApartments = this.$dataField.find('.rooms-list-item').length > 0;
    this._unsetLoading(true, hasApartments, network);
    this._eventsInit();
  }

  _updateApartmentsCount($apartmentsList) {
    if ($apartmentsList && $apartmentsList.length) {
      const $pricedApartments = $apartmentsList.find('.rooms-list-item').not('[data-no_price="true"]');
      const apartmentsCount = $pricedApartments.length;
      $apartmentsList.find('.apartments-loader__title').remove();

      if (apartmentsCount === 0) return;

      const $countBlock = $(
        `<div class="apartments-loader__title margin-bottom-8">${i18next.t('variant_found', { count: apartmentsCount })}</div>`
      );
      $apartmentsList.eq(-1).prepend($countBlock);
    }
  }

  _updateApartmentList(newHtml, options = {}) {
    const oldHtml = this.$dataField.html();
    const { skipAnimation = false, forceAnimation = false } = options;

    if (!oldHtml || skipAnimation) {
      this.$dataField.html(newHtml);
      return;
    }

    const $oldList = $('<div>').html(oldHtml);
    const $newList = $('<div>').html(newHtml);

    const $oldItems = $oldList.find('.rooms-list-item[data-apartment-id]');
    const $newItems = $newList.find('.rooms-list-item[data-apartment-id]');

    const oldIndexMap = new Map();
    $oldItems.each((index, el) => {
      const id = $(el).data('apartment-id');
      oldIndexMap.set(String(id), index);
    });

    const apartmentsIdsToAdd = [];

    $newItems.each((newIndex, el) => {
      const id = $(el).data('apartment-id');

      if (forceAnimation) {
        apartmentsIdsToAdd.push(id);
        return;
      }

      const oldIndex = oldIndexMap.get(String(id));

      if (oldIndex === undefined) {
        apartmentsIdsToAdd.push(id);
        return;
      }

      if (oldIndex !== newIndex) {
        apartmentsIdsToAdd.push(id);
      }
    });

    this.$dataField.html(newHtml);

    if (apartmentsIdsToAdd.length === 0) return;

    apartmentsIdsToAdd.forEach((id) => {
      const $el = this.$dataField.find(`[data-apartment-id="${id}"]`);

      $el.removeClass('room-fade-in');
      requestAnimationFrame(() => {
        $el.addClass('room-fade-in');
      });
    });

    this.isNewSearch = false;
  }
}

const updateUrl = (countGuests, countChildren, dateEnd, dateStart, withPet) => {
  const currentUrl = new URL(window.location.href);
  const params = new URLSearchParams(currentUrl.search);

  const setParamIfTruthy = (key, value) => {
    if (value) {
      params.set(key, value);
    }
  };

  setParamIfTruthy('count_guests', countGuests);

  let childrenAgesArr = [];

  const childrenAgesMobile = document.querySelectorAll(
    '.guest-child__input.apartments_children_ages input[name="children_ages[]"]'
  );
  if (childrenAgesMobile.length > 0) {
    childrenAgesMobile.forEach((el) => {
      childrenAgesArr.push(el.value);
    });
  } else if (countChildren && countChildren > 0) {
    childrenAgesArr = Array.from(
      document.querySelectorAll('#search-form-apartments #children_age_input'),
      (input) => input.value
    );
  }

  setParamIfTruthy('children_ages', childrenAgesArr);
  setParamIfTruthy('date_end', dateEnd);
  setParamIfTruthy('date_start', dateStart);

  if (withPet) {
    params.set('with_pet', 'true');
  } else {
    params.delete('with_pet');
  }

  const hash = window.location.hash || (/#$/.test(window.location.href) ? '#' : '');
  const newUrl = `${currentUrl.origin}${currentUrl.pathname}?${params.toString()}${hash}`;

  if (newUrl !== window.location.href) {
    history.replaceState(null, null, newUrl);
  }
};

/** Удалить из openedPopupsIdsStack хэш номера, который мог пропасть из DOM'а */
const clearApartmentHashFromHistory = () => {
  if (!window.openedPopupsIdsStack?.length) return;

  const apartmentHashIndex = window.openedPopupsIdsStack.findIndex((hash) => hash.includes('apartment-popup-'));
  if (apartmentHashIndex === -1) return;

  const apartmentHash = window.openedPopupsIdsStack[apartmentHashIndex];
  const $apartmentElement = $(`.open_popup[rel=${apartmentHash.replace('#', '')}]`);
  if (!$apartmentElement.length) return;

  window.openedPopupsIdsStack.splice(apartmentHashIndex, 1);
};

export default ApartmentsForm;
